








































import dayOfWeek from '@/filters/DayOfWeekFormatter';
import SwitchToggle from '@/components/SwitchToggle.vue';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { SalesCapacity } from '@/model/product/SalesCapacity';
import dayjs from 'dayjs';

@Component({
    filters: {dayOfWeek},
    components: {SwitchToggle}
})
export default class SalesCapacityLine extends Vue {

    /**
     * Watch for status of https://bugs.chromium.org/p/chromium/issues/detail?id=118639
     * Issue 118639: keydown and keyup events do not have proper keyCode (it's always 0)
     * This issue prevents us from implementing a better system to restrict input
     */

    @Prop({default: false}) isCateringService: boolean;

    @Prop({default: false}) hasDelay: boolean;

    @Prop({default: {}}) capacity: SalesCapacity;
    @Watch('capacity', {deep: false, immediate: true}) watchCapacity() { this.updateCapacityFromProp(this.capacity); }

    public quantity: string = '';
    @Watch('quantity') watchQuantity() { this.updateCapacityFromInput(this.quantity); }

    public delay: string = '';
    @Watch('delay') watchDelay() { this.updateDelayFromInput(this.delay); }

    public hasQuantityError: boolean = false;

    public hasDelayError: boolean = false;
    private updateCapacityFromProp(capacity: SalesCapacity) {
        this.quantity = capacity.quantity + '' ;
        this.delay = capacity.delay + '' ;
    }

    private updateCapacityFromInput(value: string) {
        this.hasQuantityError = !this.capacity.isUnlimited && !this.isValidQuantity(value);
        if (!this.hasQuantityError) {
            this.capacity.quantity = +(value);
        }

        this.notifyChange();
    }

    private updateDelayFromInput(value: string) {
        this.hasDelayError = this.hasDelay && !this.isValidDelay(value);
        if (!this.hasDelayError) {
            this.capacity.delay = +(value);
        }

        this.notifyChange();
    }

    private notifyChange() {
        this.$emit('capacityChange', {
            dayOfWeek: this.capacity.dayOfWeek,
            isQuantityValid: !this.hasQuantityError,
            isDelayValid: !this.hasDelayError
        });
    }

    public checkUnlimitedCapacity() {
        this.capacity.isUnlimited = !this.capacity.isUnlimited;
        if (!this.capacity.isUnlimited) {
            this.capacity.quantity = 0;
            this.quantity = '0';
        }
    }

    isCurrentDay(dayOfWeek: string): boolean {
        return dayjs().locale('en').format('dddd').toUpperCase() === dayOfWeek;
    }

    private isValidQuantity(quantity: string): boolean {
        return quantity != null && new RegExp(/^[0-9]*$/).test(quantity);
    }

    private isValidDelay(delay: string): boolean {
        return delay != null && new RegExp(/^[0-9]{1}$/).test(delay);
    }
}
